import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

import { CreateIndividualEntityFields } from '@shared/constants';
import { LinxRequestBenificiaryDetails } from '@shared/models';
import { otherDocumentDescription } from '@shared/utils';

@Component({
  selector: 'app-enhance-benificiary-preview',
  imports: [RktIconComponent, TitleCasePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './enhance-benificiary-preview.component.html',
})
export class EnhanceBenificiaryPreviewComponent {
  enhanceBenificiaryDetails = input<LinxRequestBenificiaryDetails>();

  enhanceBenificiaryDisplayData = input<string[]>([]);

  isEditDisabled = input<boolean>(false);

  expandRow = output();

  createBeneficiaryFields = CreateIndividualEntityFields;

  descriptionText = otherDocumentDescription;
}
